import Cookies from 'js-cookie'
import {withRouter, Link} from 'react-router-dom'

import './index.css'

const Navbar = props => {
  const onClickLogout = () => {
    const {history} = props
    Cookies.remove('jwt_token')
    history.replace('/login')
  }

  return (
    <div className="nav-container">
      <div>
        <Link to="/" className="Link">
          <img
            className="website-logo"
            src="https://assets.ccbp.in/frontend/react-js/logo-img.png"
            alt="website logo"
          />
        </Link>
      </div>
      <ul className="home-jobs-container">
        <Link className="Link" to="/">
          <li className="nav-home-text">Home</li>
        </Link>
        <Link className="Link" to="/jobs">
          <li>Jobs</li>
        </Link>
      </ul>
      <button onClick={onClickLogout} className="logout-button" type="button">
        Logout
      </button>
    </div>
  )
}
export default withRouter(Navbar)
